import { FC } from 'react';
import Tooltip from 'antd/lib/tooltip';

import { QuestionIcn } from 'utils/icons';

const QuestionMark: FC<any> = ({ children, className }) => {
  if (!children) {
    return null;
  }

  return (
    <div className={`inline-flex ml-1 text-13 cursor-help text-black-55 align-middle dark:text-black-40 ${className}`}>
      <Tooltip title={children}>
        <QuestionIcn />
      </Tooltip>
    </div>
  );
};

export default QuestionMark;
